<template>
    <div v-observe-visibility="visibilityChanged">
        <v-layout row justify-center>
            <v-dialog v-model="removeDialog" persistent max-width="350">
                <v-card>
                    <v-card-title class="headline">Delete item?</v-card-title>
                    <v-card-text>This action deletes selected item from Database, be carefull!</v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary darken-1" flat @click.native="removeDialog = false">Cancel</v-btn>
                        <v-btn color="primary darken-1" flat
                               @click.native="removeBranchOfficeContact(branchOfficeContactToDelete)">OK
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>

        <v-layout row wrap ma-2>
            <v-flex xs12 md4 ma-2>
                <v-card dark color="secondary">
                    <v-card-title>Branch Office</v-card-title>
                </v-card>
                <v-progress-linear class="branch-office-contacts-loading" :active="loading"
                                   :indeterminate="true"></v-progress-linear>

                <v-autocomplete
                        :items="customerBranchOffices"
                        item-text="name"
                        item-value="id"
                        label="Select Branch Office"
                        v-model="selectedBranchOffice"
                        required
                ></v-autocomplete>
            </v-flex>
        </v-layout>

        <v-layout row wrap ma-2>
            <v-flex xs12 md4 ma-2>


                <v-flex xs12>
                    <v-card dark color="secondary">
                        <v-card-title>Contact Persons</v-card-title>
                    </v-card>
                    <v-progress-linear class="branch-office-contacts-loading" :active="loading"
                                       :indeterminate="true"></v-progress-linear>
                </v-flex>


                <v-list class="branchOfficesContactsList" two-line subheader>

                    <template v-for="(item, index) in branchOfficeContacts">
                        <v-list-tile avatar
                                     @click="editItem(index)">
                            <v-list-tile-avatar>
                                <v-icon>account_circle</v-icon>
                            </v-list-tile-avatar>
                            <v-list-tile-content>
                                <v-list-tile-title>{{item.firstname}} {{item.lastname}}
                                </v-list-tile-title>
                                <v-list-tile-sub-title>{{item.email}} - {{item.phone}} - {{item.mobile}}
                                </v-list-tile-sub-title>
                            </v-list-tile-content>
                            <v-list-tile-action>
                                <v-btn icon ripple @click="showDeleteDialog(index)">
                                    <v-icon color="red lighten-1">delete</v-icon>
                                </v-btn>
                            </v-list-tile-action>
                        </v-list-tile>
                        <v-divider></v-divider>
                    </template>
                </v-list>
                <v-flex v-if="branchOfficeContacts == null || branchOfficeContacts.length <= 0">
                    <v-card-text><p class="text-xs-center grey--text">No Contact Persons yet</p></v-card-text>
                </v-flex>

                <v-layout mt-5 row justify-end>
                    <v-btn :disabled="addButtonDisabled" mt-5 class="secondary white--text"
                           @click="addNewContactPerson">Add
                        <v-icon class="white--text" right>add</v-icon>
                    </v-btn>
                </v-layout>

            </v-flex>

            <v-flex xs12 md7 ma-2>
                <v-layout row wrap>
                    <v-flex xs12>
                        <v-card dark color="secondary">
                            <v-card-title>Person Details</v-card-title>
                        </v-card>
                    </v-flex>

                    <v-flex xs12 md2 ma-2 ml-3>
                        <v-select :disabled="formDisabled"
                                  :items=salutions
                                  label="Salution"
                                  v-model="getSelectedBranchOfficeContact.salution"
                                  required
                        ></v-select>

                    </v-flex>

                    <v-flex xs12 md3 pl-3 py-2>
                        <v-text-field :disabled="formDisabled"
                                      v-model="getSelectedBranchOfficeContact.title"
                                      label="Title"></v-text-field>
                    </v-flex>
                    <v-flex xs12 md3 pl-3 py-2>
                        <v-text-field :disabled="formDisabled"
                                      v-model="getSelectedBranchOfficeContact.firstname"
                                      label="Firstname"></v-text-field>
                    </v-flex>
                    <v-flex xs12 md3 pl-3 py-2>
                        <v-text-field :disabled="formDisabled"
                                      v-model="getSelectedBranchOfficeContact.lastname"
                                      label="Lastname"></v-text-field>
                    </v-flex>
                    <v-flex xs12 md3 pl-3 py-2>
                        <v-text-field :disabled="formDisabled"
                                      v-model="getSelectedBranchOfficeContact.email"
                                      label="Email"></v-text-field>
                    </v-flex>
                    <v-flex xs12 md3 pl-3 py-2>
                        <v-text-field :disabled="formDisabled"
                                      v-model="getSelectedBranchOfficeContact.phone"
                                      label="Phone"></v-text-field>
                    </v-flex>
                    <v-flex xs12 md3 pl-3 py-2>
                        <v-text-field :disabled="formDisabled"
                                      v-model="getSelectedBranchOfficeContact.mobile"
                                      label="Mobile"></v-text-field>
                    </v-flex>
                    <v-flex xs12 md3 pl-3 py-2>
                        <v-text-field :disabled="formDisabled"
                                      v-model="getSelectedBranchOfficeContact.fax"
                                      label="Fax"></v-text-field>
                    </v-flex>

                    <v-flex xs12 md6 pl-3 py-2>
                        <v-autocomplete :disabled="formDisabled"
                                        label="Contact Function"
                                        persistent-hint
                                        v-model="getSelectedBranchOfficeContact.contacts_functions_id"
                                        item-value="id"
                                        item-text="name"
                                        :items="contactFunctions"
                        ></v-autocomplete>
                    </v-flex>

                    <v-flex xs12 md3 pl-3 py-2>
                        <v-switch color="secondary" label="Main Contact"
                                  v-model="getSelectedBranchOfficeContact.main_contact"></v-switch>
                    </v-flex>

                </v-layout>

                <v-layout mt-5 row justify-end>
                    <v-btn :disabled="formEdited" mt-5 class="secondary white--text"
                           @click.native="saveContactPersons(3)">Save
                        <v-icon class="white--text" right>save</v-icon>
                    </v-btn>
                </v-layout>

            </v-flex>
        </v-layout>

    </div>
</template>


<script>
    import {
        Settings,
        Customer,
        CustomerBranchOfficeContact,
        CustomerBranchOffice,
        ContactFunctionsSettings
    } from '../../store/namespace-helper'

    export default {
      name: 'contact-persons',
      data () {
        return {
          countries: this.$store.getters.countries,
          isVisible: false,
          removeDialog: false,
          branchOfficeContactToDelete: null,
          onDismissed: false,
          contactPersonsUpdated: 0,
          selectedBranchOffice: null,
          salutions: [
            'Mr.',
            'Mrs.',
            'Company'
          ]
        }
      },
      methods: {
        visibilityChanged (isVisible, entry) {
          if (this.isVisible !== isVisible) {
            this.isVisible = isVisible
            if (isVisible) {
              this.loadCustomerBranchOffices()
              this.loadAllContactFunctions()
            } else {
              this.branchOfficeUpdated = 0
            }
          }
        },
        loadCustomerBranchOffices () {
          this.$store.dispatch(CustomerBranchOffice.actions.loadCustomerBranchOffices, this.selectedCustomer.id)
        },
        loadAllContactFunctions () {
          this.$store.dispatch(ContactFunctionsSettings.actions.loadAllContactFunctions)
        },
        loadContactPersons (branchOfficeID) {
          this.$store.dispatch(CustomerBranchOfficeContact.actions.loadContactPersons, branchOfficeID)
        },
        editItem (index) {
          this.$store.dispatch(CustomerBranchOfficeContact.actions.setSelectedContactPerson, this.branchOfficeContacts[index])
        },
        showDeleteDialog (index) {
          this.removeDialog = true
          this.branchOfficeContactToDelete = index
        },
        removeBranchOfficeContact (index) {
          this.removeDialog = false
          this.$store.dispatch(CustomerBranchOfficeContact.actions.removeContactPerson, this.branchOfficeContactToDelete)
          this.contactPersonsUpdated = 0
        },
        addNewContactPerson () {
          let contactPerson = {
            id: 0,
            salution: null,
            title: null,
            firstname: 'Firstname',
            lastname: 'Lastname',
            email: null,
            phone: null,
            fax: null,
            mobile: null,
            main_contact: false,
            contacts_functions_id: null,
            customers_branch_offices_id: this.selectedBranchOffice
          }
          this.$store.dispatch(CustomerBranchOfficeContact.actions.addNewContactPerson, contactPerson)
          this.$store.dispatch(CustomerBranchOfficeContact.actions.setSelectedContactPerson, contactPerson)
        },
        saveContactPersons (index) {
          this.$store.dispatch(CustomerBranchOfficeContact.actions.saveContactPersons, this.branchOfficeContacts)
          this.contactPersonsUpdated = 0
        }

      },
      computed: {
        selectedCustomer () {
          return this.$store.getters[Customer.getters.getSelectedCustomer]
        },
        customerBranchOffices () {
          if (this.$store.getters[CustomerBranchOffice.getters.getCustomerBranchOffices] == null) {
            return []
          }
          return this.$store.getters[CustomerBranchOffice.getters.getCustomerBranchOffices]
        },
        branchOfficeContacts () {
          return this.$store.getters[CustomerBranchOfficeContact.getters.getContactPersons]
        },
        contactFunctions () {
          return this.$store.getters[ContactFunctionsSettings.getters.getAllContactFunctions]
        },
        getSelectedBranchOfficeContact () {
          return this.$store.getters[CustomerBranchOfficeContact.getters.getSelectedContactPerson]
        },
        loading () {
          return this.$store.getters[Settings.getters.loading]
        },
        formEdited () {
          console.log('branch office formEdited: ' + this.branchOfficeUpdated)
          return this.contactPersonsUpdated < 2
        },
        addButtonDisabled () {
          return this.selectedBranchOffice === null
        },
        formDisabled () {
          return this.getSelectedBranchOfficeContact === null
        }

      },
      watch: {
        branchOfficeContacts: {
          handler (val) {
            console.log('branchOfficeContacts data changed: ' + JSON.stringify(val))
            this.contactPersonsUpdated++
          },
          deep: true
        },
        selectedBranchOffice: {
          handler (val) {
            console.log('selectedBranchOffice data changed: ' + JSON.stringify(val))
            this.loadContactPersons(val)
          },
          deep: true
        }
      }
    }
</script>

<style scoped>

    .branchOfficesContactsList {
        max-height: 50vh;
        overflow: scroll;
        margin-top: -20px;
    }

    .branchOfficesContactsList::-webkit-scrollbar {
        display: none;
    }

    .branch-office-contacts-loading {
        margin-top: 0px;
    }

</style>


// WEBPACK FOOTER //
// src/components/Customers/CustomerContactPersons.vue